import React, {
  useContext,
  useState
} from 'react';
import {
  ELSPropsFromToastService,
  ELSWithToastService
} from '@els/els-component-toast-react';
import {
  ELSPropsFromModalService,
  ELSWithModalService
} from '@els/els-component-modal-react';
import { flowRight } from 'lodash';
import AiChatBaseTemplate from '../../components/ai-chat-base-template/AiChatBaseTemplate.component';
import { AppContext } from '../../components/app/AppProvider.component';
import { useHistory } from 'react-router';
import withHTMLHeadSEO from '../../hocs/with-html-head-seo/withHTMLHeadSEO.hoc';
import {
  handleChatClickAction,
} from '../../components/app/app-state-actions.utilities';
import { getSortedChats } from '../ai-chat/ai-chat.utilities';
import { FlexLayout } from '../../components/flex/FlexLayout.component';
import { FlexLayoutModifier } from '../../components/flex/flex.constants';
import { FlexItem } from '../../components/flex/FlexItem.component';
import { ELSTextBox } from '@els/els-component-form-field-react';
import moment from 'moment/moment';
import { DATE_TIME_PRIMARY } from '../../constants/date.constants';
import { RoutePath } from '../../components/app/app.constants';
import { preserveAdminOverrideParam } from '../../utilities/app.utilities';
import { RecordEmpty } from '../../models/common.models';
import ChatActionMenu from '../../components/chat-action-menu/ChatActionMenu.component';
import { filterBySearchQuery } from '../../utilities/common.utilities';

export type YourChatsProps = ELSPropsFromModalService
  & ELSPropsFromToastService;

export type YourChatsState = {
  filter: string;
}

export const YourChatsComponent = (props: YourChatsProps): JSX.Element => {

  const {
    appState,
    setAppState,
    appStateRef
  } = useContext(AppContext);
  const [state, setState] = useState<YourChatsState>({
    filter: '',
  });
  const history = useHistory();

  const {
    toastService
  } = props;

  return (
    <AiChatBaseTemplate
      isPanelOpen={false}
      panelContent={null}
    >
      <div className="c-naa-base-page">
        <div className="c-naa-base-page__header">
          <div className="c-naa-base-page__inner">
            <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS]}>
              <FlexItem modifiers={[FlexLayoutModifier.GROW]}>
                <h3>Your chats</h3>
              </FlexItem>
              <FlexItem>
                <button
                  className="u-els-anchorize u-els-debuttonize"
                  type="button"
                  onClick={() => history.push(preserveAdminOverrideParam(RoutePath.AI_CHAT, history.location.search))}
                  aria-label="Back to chat"
                >
                  Back to chat
                </button>
              </FlexItem>
            </FlexLayout>
          </div>
        </div>
        <div className="c-naa-base-page__body">
          <div className="c-naa-base-page__inner">

            <div>
              <ELSTextBox name="editChatTitleInput"
                value={state.filter}
                changeHandler={(e, filter) => {
                            setState((prevState) => {
                              return { ...prevState, filter }
                            });
                          }}>
                Search chats
              </ELSTextBox>
            </div>

            <div>
              <ol
                aria-label="List of previous chats"
                className="c-naa-your-chats"
              >
                {
                  appState.chats && getSortedChats(appState.chats)
                    .filter((chat) => {
                      if (!chat.title) {
                        return !state.filter;
                      }
                      return filterBySearchQuery(state.filter, chat.title.split(' '))
                    })
                    .map((chat) => {
                      return (
                        <li
                          key={chat.id}
                          aria-label={`Chat title: ${chat.title}`}
                          className="c-naa-your-chats__item"
                        >
                          <FlexLayout modifiers={[FlexLayoutModifier.GUTTERS]}>
                            <FlexItem modifiers={[FlexLayoutModifier.GROW]} classes={['c-naa-your-chats__title-column']}>
                              <button
                                className="u-els-anchorize u-els-debuttonize u-els-display-block c-naa-your-chats__title-button"
                                type="button"
                                onClick={() => {
                                  handleChatClickAction({
                                    appState,
                                    appStateRef,
                                    setAppState,
                                    chat,
                                    sendClickEvent: true,
                                    checkLoading: true,
                                    toastService,
                                  });
                                  history.push(preserveAdminOverrideParam(RoutePath.AI_CHAT, history.location.search))
                                }}
                                title={chat.title}
                              >
                                {chat.title}
                              </button>
                              <div><small>{moment(chat.createdAt).format(DATE_TIME_PRIMARY)}</small></div>
                            </FlexItem>
                            <FlexItem>
                              <ChatActionMenu chat={chat} idPrefix="your-chats" />
                            </FlexItem>
                          </FlexLayout>
                        </li>
                      );
                    })
                }
              </ol>
            </div>
          </div>
        </div>
      </div>
    </AiChatBaseTemplate>
  );
};

const enhance = flowRight(
  ELSWithToastService,
  ELSWithModalService,
  withHTMLHeadSEO({ title: 'Your chats' }),
);

const YourChats: React.FC<RecordEmpty> = enhance(YourChatsComponent);

export default YourChats;
